var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoZignetWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 202,
    viewBox: "0 0 443 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8973_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.254 133.638L68.3745 133.762C68.3745 133.88 63.4478 137.772 60.37 141.057L57.3136 144.217H85.2555L94.8651 134.002V114.911H23.9238V134.002H54.826C60.2474 134.002 68.1223 133.638 68.2539 133.638L68.254 133.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5977 181.303L50.4707 181.181C50.4707 181.057 54.6278 177.045 58.4221 173.035L81.8031 147.991H53.9882L22.4756 180.932V200.023H94.8632V180.932H63.9255C56.5896 180.932 50.7181 181.303 50.5976 181.303H50.5977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.183 168.352H193.683V168.472C191.236 174.793 185.247 181.846 171.544 181.846C157.483 181.846 147.338 172.484 147.338 157.531C147.338 154.105 147.866 150.922 148.877 148.054H126.882C126.262 151.079 125.939 154.244 125.939 157.531C125.939 183.181 145.747 201.788 170.327 201.788C178.764 201.788 188.541 198.503 193.561 193.155H193.683C193.683 193.277 193.561 194.494 193.561 200.09H211.171V151.935H171.183V168.352V168.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.596 144.277C154.367 137.612 161.238 133.452 170.33 133.452C177.051 133.452 184.264 136.495 188.301 141.358L209.218 135.885C201.51 122.023 186.959 113.264 170.33 113.264C150.222 113.264 133.325 125.714 127.83 144.277H150.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.373 144.277C257.964 142.36 256.698 140.633 255.678 139.29L237.462 114.976H218.157V144.277H259.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.929 144.277V114.976H274.39V134.428C274.39 137.779 274.401 141.108 274.421 144.277H294.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.433 148.055C274.502 157.669 274.591 164.946 274.506 164.946H274.391C274.295 164.946 267.866 155.952 262.126 148.055H218.157V200.091H238.683V181.235C238.683 162.638 238.442 149.5 238.567 149.5H238.683C238.806 149.5 250.296 165.675 258.121 176.377L275.614 200.091H294.929V148.055H274.433V148.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.778 144.277V134.061H364.478V114.976H302.23V144.277H322.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.778 165.917H355.43V148.055H302.23V200.089H365.207V180.996H322.778V165.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.467 114.975V134.061H396.137V144.276H416.676V134.061H442.727V114.975H370.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.137 200.091H416.678V148.055H396.137V200.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.692 144.21V114.887H101.394L101.409 144.21H121.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.356 147.941L101.332 147.988L101.356 199.874H121.692V147.941H101.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.291 49.3615C198.016 44.9394 220.782 24.4926 235.788 11.3421C235.964 11.2019 236.064 11.1265 236.064 11.1265L236.004 11.1468C243.411 4.66356 248.864 0 248.864 0C113.613 32.6805 0.000976562 0.56298 0.000976562 0.56298C108.955 34.6462 200.327 23.799 201.841 23.6147C201.817 23.6613 201.789 23.7077 201.763 23.7521C192.307 36.3414 149.317 72.8358 149.317 72.8358L149.531 72.7274C149.401 72.8446 149.324 72.9112 149.324 72.9112C284.571 40.2317 398.186 72.3483 398.186 72.3483C298.644 41.2087 211.745 47.8409 196.291 49.3615V49.3615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 82.7361C153.304 78.1502 234.63 54.4315 339.353 64.8178C339.353 64.8178 220.667 56.302 96.8525 115.303C96.8525 115.303 137.144 83.9816 138.608 82.7361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8973_1047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 442.729,
    height: 201.788,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZignetWhite);
export default __webpack_public_path__ + "static/media/logo_zignet_white.87b642c1e36dfdf967b978fc25280924.svg";
export { ForwardRef as ReactComponent };